import { useState, createContext, useContext, useEffect } from 'react'
import { useHistory } from "react-router-dom"
import { auth } from "../lib/firebase.js"
import FullPageCenterItems from "../components/FullPageCenterItems"
import Spinner from "../components/Spinner"

export const AuthContext = createContext()
export const useAuth = () => useContext(AuthContext)

export function AuthProvider(props) {
    const [status, setStatus] = useState("loading")
    const [authenticatedUser, setAuthenticatedUser] = useState()
    const history = useHistory()
    const loading = status === "loading"

    function signup(email, password) {
        return auth.createUserWithEmailAndPassword(email, password)
    }

    function login(email, password) {
        return auth.signInWithEmailAndPassword(email, password)
    }

    async function logout() {
        try {
            await auth.signOut()
            return history.push("/")
        } catch (err) {
            console.log(err.message)
        }
    }

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setAuthenticatedUser(user)
            setStatus("idle")
        })
        return unsubscribe
        // eslint-disable-next-line
    }, []);


    return (
        <AuthContext.Provider value={{ signup, login, logout, authenticatedUser }}>
            {
                loading ? (
                    <FullPageCenterItems fullscreen>
                        <Spinner color="text-gray-700" />
                    </FullPageCenterItems>
                ) : props.children
            }
        </AuthContext.Provider>
    )
}